import { render, staticRenderFns } from "./coachStatistics.vue?vue&type=template&id=56cb969b&scoped=true&"
import script from "./coachStatistics.vue?vue&type=script&lang=js&"
export * from "./coachStatistics.vue?vue&type=script&lang=js&"
import style0 from "./coachStatistics.vue?vue&type=style&index=0&id=56cb969b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cb969b",
  null
  
)

export default component.exports